/*!
* Copyright (c) 2018, Okta, Inc. and/or its affiliates. All rights reserved.
* The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
*
* You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
* WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
*
* See the License for the specific language governing permissions and limitations under the License.
*/

<template>
  <div id="home">
    <h1 class="ui header">Hello</h1>
    <div v-if="!this.$parent.authenticated">
      <p>
        We are very glad you are choosing to grow your business with Liveops. 
      </p>
      <p>
        The button below will take you to a screen where you will sign in with your Liveops Nation Okta credentials. Follow the instructions and you will be redirected to our application tracking system to continue the process. 
      </p>
      <p>
        Thank you, and we wish you the best as you continue on your journey.
      </p>

      <router-link id="login-button" class="big ui animated button blue" role="button" to="/login">
        <div class="visible content">Login</div>
        <div class="hidden content">
          <i class="right arrow icon"></i>
        </div>
      </router-link>
    </div>

    <div v-if="this.$parent.authenticated">
      <div class="ui warning message" v-if="this.error==true">
        <div class="header">We ran into an error..</div>
        <a class="big ui animated fade button gray" @click="refresh">
          <div class="visible content">Refresh</div>
          <div class="hidden content"><i class="undo icon"></i></div>
        </a>
      </div>
      <div v-if="this.id && this.error==false">
        <div class="ui active large centered inline loader"></div>
      </div>
      <div v-if="this.create == true">
        <h2>{{claims.name}}!</h2>
        Let's create a new application.
        <br>
        <form class="ui form" v-bind:class="{warning:create_info.warning, loading:processing}" name="create-form">
          <div class="field">
            <div class="two fields">
              <div class="field">
                <label>First Name</label>
                <div class="ui left icon input">
                  <input type="text" name="given" placeholder="First Name" v-model="first_name">
                  <i
                    v-bind:class="{'check icon green':create_info.first_name.valid, 'exclamation icon red':!create_info.first_name.valid}"></i>
                </div>
              </div>
              <div class="field">
                <label>Last Name</label>
                <div class="ui left icon input">
                  <input type="text" name="last" placeholder="Last Name" v-model="last_name">
                  <i
                    v-bind:class="{'check icon green':create_info.last_name.valid, 'exclamation icon red':!create_info.last_name.valid}"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="field">
            <div class="two fields">
              <div class="field">
                <label>Email</label>
                <div class="ui left icon input">
                  <input type="text" name="given" placeholder="Email" v-model="email">
                  <i
                    v-bind:class="{'check icon green':create_info.email.valid, 'exclamation icon red':!create_info.email.valid}"></i>
                </div>
              </div>
              <div class="field">
                <label>Phone Number</label>
                <div class="ui left icon input">
                  <input type="text" name="last" placeholder="Phone Number" v-model="phone" maxlength="10">
                  <i
                    v-bind:class="{'check icon green':create_info.phone.valid, 'exclamation icon red':!create_info.phone.valid}"></i>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div class="big ui animated button blue" v-bind:class="{disabled:create_info.warning}"
           v-on:click="createApp">
          <div class="visible content">Submit</div>
          <div class="hidden content">
            <i class="right arrow icon"></i>
          </div>
        </div>
      </div>
      <div v-bind:style="debugStyle">{{id}}<br>{{portal}}<br>{{claims.sub}}</div>
    </div>
  </div>
</template>
 
<script>
  import axios from "axios"
  export default {
    name: 'home',
    data: function () {
      var id = null;
      var portal = null;
      var stage = null;
      var phone = null;
      var fountainInfo = {};
      if (localStorage.getItem("phone") !== null) {
        if (!phone) {
          phone = localStorage["phone"];
        }
      }
      if (localStorage.getItem("fountain-info") !== null) {
        fountainInfo = JSON.parse(localStorage["fountain-info"]);
        if (!id) {
          id = fountainInfo.id;
        }
        if (!portal) {
          portal = fountainInfo.portal;
        }
        if (!stage) {
          stage = fountainInfo.stage;
        }
      } else {
        console.log("No Fountain Info Object Detected")
      }

      return {
        id: id,
        portal: portal,
        stage: stage,
        claims: '',
        token: '',
        first_name: null,
        last_name: null,
        email: null,
        phone: phone,
        create_error: false,
        processing: false,
        advance: false,
        error: false,
        create: false,
        fountainInfo: fountainInfo,
        debugStyle: {
          color: 'lightgrey',
          fontSize: '10px',
          textAlign: 'center'
        }
      }
    },
    computed: {
      name: function () {
        return this.first_name + ' ' + this.last_name
      },
      create_info: function () {
        var email_test = new RegExp(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
        var name_test = new RegExp(/^[a-z ,.'-]+$/i);
        var phone_test = new RegExp(/^\d{10}$/);

        var first_valid = name_test.test(this.first_name);
        var last_valid = name_test.test(this.last_name);
        var email_valid = email_test.test(this.email)
        var phone_valid = phone_test.test(this.phone)
        var warn = !(first_valid &&
          last_valid &&
          email_valid &&
          phone_valid)
        return {
          "first_name": {
            "value": this.first_name,
            "valid": first_valid
          },
          "last_name": {
            "value": this.last_name,
            "valid": last_valid
          },
          "email": {
            "value": this.email,
            "valid": email_valid
          },
          "phone": {
            "value": this.phone,
            "valid": phone_valid
          },
          "warning": warn
        }
      }

    },
    created() {
      this.setup()
    },
    methods: {
      verifyToken() {
        axios.get(
          'https://us-central1-business-intelligence-287618.cloudfunctions.net/liveops-fountain-api/verify', {
            headers: {
              Authorization: 'Bearer ' + this.token
            }
          }
        ).then(response => {
          console.log(response.data);
        }, error => {
          console.log(error);
        });
      },
      refresh() {
        localStorage.removeItem("fountain-info");
        this.logout();
        if(this.portal){
          window.location.href = this.portal;
        } else {
          window.location.href = window.location + 'login'
        }
      },
      advanceApp() {
        console.log("Signed in, App ID Detected, Triggering Flow Advance")

        var params = this.stage ? this.fountainInfo.id + '/' + this.claims.sub + '/' + this.claims.global_id + '/' + this.stage + '/' : this.fountainInfo.id + '/' + this.claims.sub + '/' + this.claims.global_id 
        console.log(params)
        axios({
            method: 'get',
            url: 'https://us-central1-business-intelligence-287618.cloudfunctions.net/liveops-fountain-api/api/advance/' + params ,
            headers: {
              Authorization: 'Bearer ' + this.token
            }
          })
          .then(response => {
            console.log(response.data);
            localStorage.removeItem("fountain-info");
            localStorage["fountain-response"] = JSON.stringify(response);
            window.location.href = this.portal;
          }, error => {
            this.processing = false;
            this.error = true;
            console.log(error);
          });
      },
      createApp() {
        if (!this.create_info.warning) {
          console.log("Creating Application")
          this.processing = true;
          axios({
              method: 'post',
              url: 'https://us-central1-business-intelligence-287618.cloudfunctions.net/liveops-fountain-api/api/create',
              data: {
                "global_id": this.claims.global_id,
                "okta_id": this.claims.sub,
                "full_name": this.name,
                "email": this.email,
                "phone_number": this.phone
              },
              headers: {
                Authorization: 'Bearer ' + this.token
              }
            })
            .then(response => {
              console.log(response.data);
              console.log(response.data.portal_url);
              this.create = false;
              this.processing = false;
              this.portal = response.data.portal_url;
              localStorage["fountain-response"] = JSON.stringify(response);
              localStorage.removeItem("phone")
              window.location.href = this.portal;
            }, error => {
              this.processing = false;
              this.error = true;
              console.log(error);
            });
        }
      },
      async setup() {
        this.claims = await this.$auth.getUser()
        this.token = await this.$auth.getAccessToken()
        if (this.claims) {
          if (this.fountainInfo.id == null) {
            console.log("Signed in, but no App ID, Triggering New App Create")
            this.create = true;
            this.first_name = this.claims.given_name;
            this.last_name = this.claims.family_name;
            this.email = this.claims.email;
            this.phone ? this.claims.phone : null;
          } else {
            this.advanceApp();
          }
        }
      },
     async logout () {
      await this.$auth.logout()
      await this.isAuthenticated()
    }
    }
  }

</script>
